import { render, staticRenderFns } from "./BillRecord.vue?vue&type=template&id=7a8f7974"
import script from "./BillRecord.vue?vue&type=script&lang=ts"
export * from "./BillRecord.vue?vue&type=script&lang=ts"
import style0 from "./BillRecord.vue?vue&type=style&index=0&id=7a8f7974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports